import { useTranslation } from 'react-i18next';

import { Game } from '../lobby';

import { CreateGameSection, LiveGamesSection } from 'modules/lobby-page/components';

import DesktopLayout from 'shared/components/layout/desktop-layout';
import { useAccount } from 'shared/hooks/use-web3';
import { RoomInfo } from 'shared/types/app-types';
import { CurrencyType } from 'shared/web3/utils/getCurrencyInfo';

interface IDesktopViewProps {
  approveAllowanceHandler: (fullAllowance: boolean, bet: number) => void;
  startGameHandler: (bet: number, wins: number, playerB: string, currency?: CurrencyType) => void;
  joinRoomHandler: (roomId: number) => void;
  games: Game[];
  activeGames: RoomInfo[];
}

export const DesktopView = ({
  approveAllowanceHandler,
  startGameHandler,
  joinRoomHandler,
  games,
  activeGames,
}: IDesktopViewProps) => {
  const { t } = useTranslation();
  const { chainId } = useAccount();

  return (
    <DesktopLayout title={t('pages.lobby')}>
      <div className="mb-4 flex flex-1 flex-col items-stretch justify-end gap-2 lg:flex-row lg:justify-between xlg:mb-16 xlg:gap-8">
        <LiveGamesSection
          key={chainId}
          joinRoomHandler={joinRoomHandler}
          startGameHandler={startGameHandler}
          approveAllowanceHandler={approveAllowanceHandler}
          games={games}
          activeGames={activeGames}
        />
        <CreateGameSection
          approveAllowanceHandler={approveAllowanceHandler}
          startGameHandler={startGameHandler}
        />
      </div>
    </DesktopLayout>
  );
};
